const { Core, Events, Utils } = Global;
const { $replaceContent, $state } = Utils;

const HORIZONTAL_VIEW_CN = '@list';
const INIT_CN = 'init';

customElements.define('collection-products', class extends Core {
    elements = {
        $: ['products-container']
    }

    propTypes = {
        'user-switchable': Boolean
    }
    
    render() {
        this.sub(Events.COLLECTION_UPDATED, this._handleCollectionUpdate);
        this.prop('user-switchable') && this.sub(Events.COLLECTION_VIEW_CHANGE, this._toggleHorizontalView, { global: true });
        this._sortProductsQueued();
    }

    _handleCollectionUpdate({ doc, src }) {
        if(src !== 'dynamic-pagination') {
            this.updateContentFrom(doc);
            this._sortProductsQueued();
            return;
        }

        const targetContainer = doc.getElementById(this.id)?.querySelector(this.elements['products-container']);
        if (!targetContainer) {
            return;
        }

        const additionalProducts = Array.from(targetContainer.children);

        this.$('products-container')
            .append(...additionalProducts);

        this._sortProductsQueued();
    }

    _toggleHorizontalView({ horizontalViewState, first }) {
        this.classList.toggle(HORIZONTAL_VIEW_CN, horizontalViewState);
        first && $state(this, INIT_CN, false);
    }

    _sortProductsQueued() {
        if (this._sortRaf) {
            cancelAnimationFrame(this._sortRaf);
        }

        this._sortRaf = requestAnimationFrame(() => {
            this._sortProducts();
            this._sortRaf = null;
        });
    }

    _sortProducts() {
        const container = this.$('products-container');
        if (!container) {
            return;
        }

        const products = Array.from(container.children);
        if (products.length <= 1) {
            return;
        }

        const sorted = products
            .map((node, index) => ({
                node,
                index,
                available: this._isAvailable(node)
            }))
            .sort((a, b) => {
                if (a.available === b.available) {
                    return a.index - b.index;
                }

                return a.available ? -1 : 1;
            })
            .map(({ node }) => node);

        container.append(...sorted);
    }

    _isAvailable(node) {
        const value = node?.dataset?.available;
        if (value === undefined) {
            return true;
        }

        return value !== 'false' && value !== '0';
    }
})
